// extracted by mini-css-extract-plugin
module.exports = {"tabContent":"TabNavHorizontal_tabContent__1Z0hJ","button":"TabNavHorizontal_button__31z3_"};